'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsAsideComponent = exports.newsAsideComponent = {
    template: require('./news-aside.html'),
    bindings: {
        topNewsitems: '=',
        errorOccurred: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.newsSliderSettings = {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchMove: false,
                adaptiveHeight: false
            };
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/news/components/news-aside.js
// module id = 944
// module chunks = 0